// Modules
import { Component, OnInit, Inject } from '@angular/core';

// Angular Material
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';

@Component({
    selector: 'dispatcher-companies-modal',
    templateUrl: './dispatcher-companies-modal.component.html',
    styleUrls: ['./dispatcher-companies-modal.component.scss'],
    standalone: false
})
export class DispatcherCompaniesModalComponent implements OnInit {
  public dispatcherCompanies: string[];
  public dataSource: MatTableDataSource<any> = null;
  public displayedColumns: string[] = ['managedCompany', 'company'];
  // Constructor
  constructor(
    public dialogRef: MatDialogRef<DispatcherCompaniesModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any[]
  ) {}

  ngOnInit() {
    // Set user dispatcher companies
    this.dispatcherCompanies = this.data;
    this.dataSource = new MatTableDataSource(this.dispatcherCompanies);
  }
}
